import { render, staticRenderFns } from "./fee-detail.vue?vue&type=template&id=921d2dcc"
import script from "./fee-detail.vue?vue&type=script&lang=js"
export * from "./fee-detail.vue?vue&type=script&lang=js"
import style0 from "./fee-detail.vue?vue&type=style&index=0&id=921d2dcc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports